import request from '@/utlis/request'

// 查询 待上拍列表
export function GetUpbeatList(data) {
    return request({
        url: '/admin/car/findCarByCondition',
        method: 'post',
        data: {
            ...data,
            type: '6'
        }
    })
}

/**
 * 内网中标
 * @param {*} params
 * @returns
 */
export function findBidsUpdateBid(data) {
    return request({
        url: '/admin/bids/update-bid',
        method: 'POST',
        data
    })
}

// 查询 上拍列表
export function GetFindOfferListPage(params) {
    return request({
        url: '/admin/offer/findOfferListPage',
        method: 'GET',
        params: {
            ...params,
            insuranceCompany: "平安"

        }
    })
}


/**
 * 专场 已上拍列表
 */
export function findCarSpecialByCondition(data) {
    return request({
        url: '/admin/car/special/findCarSpecialByCondition',
        method: 'POST',
        data: {
            ...data,
            type: 6
        }
    })
}


/**
 * 查看上拍详细信息
 */
export function getUpbeatDetail(params) {
    return request({
        url: '/admin/upbeat/getUpbeatDetail',
        method: 'GET',
        params: {
            ...params,
            // 区分专场和名拍的列表查询 type=special 是专场
            type: params.type
        }
    })
}


/**
 * 批量确认上拍
 */
export function confirmAuction(data, modeType) {
    return request({
        url: `/admin/upbeat/confirmAuction`,
        method: 'post',
        data,
        params: {
            type: modeType
        }
    })
}


/**
 * 期车上拍
 */
export function upbeatOffer(data) {
    return request({
        url: `/admin/upbeat/offer`,
        method: 'POST',
        data
    })
}


/**
 * 取消发布 - 批量
 * @param {*} params
 * @returns
 */
export function cancelAuction(params) {
    return request({
        url: '/admin/auction/cancelAuction',
        method: 'post',
        params
    })
}



/**
 * 获取平安报价详情
 * @param {*} data
 * @returns
 */
export function getFindPinganOfferDetail(params) {
    return request({
        url: '/admin/offer/findPinganOfferDetail',
        method: 'GET',
        params
    })
}

/**
 * 获取人保报价详情
 * @param {*} data
 * @returns
 */
export function getFindRenbaoOfferDetail(params) {
    return request({
        url: '/admin/offer/findRenbaoOfferDetail',
        method: 'GET',
        params
    })
}


/**
 * 获取太平洋报价详情
 * @param {*} data
 * @returns
 */
export function getFindTaipingyangOfferDetail(params) {
    return request({
        url: '/admin/offer/findTaipingyangOfferDetail',
        method: 'GET',
        params
    })
}

/**
 * 获取暗拍详情 原始数据
 */
export function getFindZhufengOfferDetail(params) {
    return request({
        url: `/admin/bids/${params.id}`,
        method: 'GET',
    })
}
/**
 * 获取暗拍详情 修改后数据
 */
export function getFindZhufengOfferDetailInfo(params) {
    return request({
        url: `/admin/bids/info/${params.id}`,
        method: 'GET',
    })
}



/**
 * 获取其他报价详情
 * @param {*} data
 * @returns
 */
export function getFindOtherOfferDetail(params) {
    return request({
        url: '/admin/offer/findOtherOfferDetail',
        method: 'GET',
        params
    })
}


/**
 * 分页获取中标列表
 * @param {*} data
 * @returns
 */
export function getFindWinbidListPage(params) {
    return request({
        url: '/admin/winbid/findWinbidListPage',
        method: 'GET',
        params: {
            ...params,
            insuranceCompany: "平安"
        }
    })
}

/**
 * 获取平安中标详情
 * @param {*} data
 * @returns
 */
export function getFindPinganWinbidDetail(params) {
    return request({
        url: '/admin/winbid/findPinganWinbidDetail',
        method: 'GET',
        params
    })
}


/**
 * 获取人保中标详情
 * @param {*} data
 * @returns
 */
export function getFindRenbaoWinbidDetail(params) {
    return request({
        url: '/admin/winbid/findRenbaoWinbidDetail',
        method: 'GET',
        params
    })
}

/**
 * 获取太平洋中标详情
 * @param {*} data
 * @returns
 */
export function getFindTaipingyangWinbidDetail(params) {
    return request({
        url: '/admin/winbid/findTaipingyangWinbidDetail',
        method: 'GET',
        params
    })
}
/**
 * 转app暗拍
 */
export function upgradeToVip(data) {
    return request({
        url: '/admin/sysuser/upgradeToVip',
        method: 'POST',
        data
    })
}

/**
 * 获取其他中标详情
 * @param {*} data
 * @returns
 */
export function getFindOtherWinbidDetail(params) {
    return request({
        url: '/admin/winbid/findOtherWinbidDetail',
        method: 'GET',
        params
    })
}

/**
 * 查询会员列表
 * @param {*} data
 * @returns
 */
export function getFindMemberManageList(params) {
    return request({
        url: '/admin/memberManage/findVipUserList',
        method: 'GET',
        params
    })
}

export function getFindMemberManageList2(params) {
    return request({
        url: '/admin/memberManage/findVipUserList2',
        method: 'GET',
        params
    })
}
export function findVipUserListByGroupIds(data) {
    return request({
        url: '/admin/memberManage/findVipUserListByGroupIds',
        method: 'POST',
        data
    })
}


/**
 * 添加报价分配会员
 * @param {*} data
 * @returns
 */
export function InsertOfferPinganRelaxUser(data) {
    return request({
        url: '/admin/offer/relax/insertOfferPinganRelaxUser',
        method: 'POST',
        data
    })
}
export function InsertOfferPinganRelaxUser2(data) {
    return request({
        url: '/admin/offer/relax/insertOfferPinganRelaxUser2',
        method: 'POST',
        data
    })
}
// /**
//  * 查看分配人员
//  * @param {*} data
//  * @returns
//  */
// export function FindUsersById(data) {
//     return request({
//         url: '/admin/offer/relax/findUsersById',
//         method: 'POST',
//         data
//     })
// }



// 查询 待上拍列表
export function GetWaitUpbeatList(data) {
    return request({
        url: '/admin/car/findCarByCondition',
        method: 'post',
        data: {
            ...data,
            type: data.type ? data.tyep : 5
        }
    })
}
// 获取车辆上拍成本信息
export function getCarUpbeatCost(params) {
    return request({
        url: '/admin/upbeat/getCarUpbeatCost',
        method: 'get',
        params
    })
}
// 对车辆进行上拍
export function getAdd(data) {
    return request({
        url: '/admin/upbeat/add',
        method: 'post',
        data
    })
}
// 修改车辆上拍信息
export function updateInfo(data) {
    return request({
        url: '/admin/upbeat/updatecarupbeat',
        method: 'post',
        data
    })
}
// 根据 拍卖会ID查询拍卖会信息
export function GetIdInfo(params) {
    return request({
        url: '/admin/auction/findAuctionById',
        method: 'get',
        params
    })
}



/**
 * 退回整备
 */
export function backToPrepare(data) {
    return request({
        url: '/admin/upbeat/backToPrepare',
        method: 'post',
        data
    })
}

/**
 * 转App期车
 */
export function downgradeToApp(data) {
    return request({
        url: '/admin/offer/downgradeToApp',
        method: 'PUT',
        data
    })
}

/**
 * 暗拍填写上拍信息
 */
export function bidsPrice(data) {
    return request({
        url: '/admin/bids/price',
        method: 'PUT',
        data
    })
}

/**
 * 新增二手车
 */
export function addSecondHandCar(data) {
    return request({
        url: '/admin/offer/addSecondHandCar',
        method: 'POST',
        data
    })
}


/**
 * 新增大地
 */
export function addOtherOffer(data) {
    return request({
        url: '/admin/offer/addOtherOffer',
        method: 'POST',
        data
    })
}
